var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0323 1.67742C12.0323 1.30329 12.3355 1 12.7097 1H16.3226C16.6967 1 17 1.30329 17 1.67742V5.29032C17 5.66445 16.6967 5.96774 16.3226 5.96774C15.9485 5.96774 15.6452 5.66445 15.6452 5.29032V3.31285L11.3822 7.57578C11.1177 7.84033 10.6888 7.84033 10.4242 7.57578C10.1597 7.31123 10.1597 6.88232 10.4242 6.61777L14.6871 2.35484H12.7097C12.3355 2.35484 12.0323 2.05155 12.0323 1.67742ZM5.48387 4.16129C4.86032 4.16129 4.35484 4.66678 4.35484 5.29032V12.5161C4.35484 13.1397 4.86032 13.6452 5.48387 13.6452H12.7097C13.3332 13.6452 13.8387 13.1397 13.8387 12.5161V8C13.8387 7.62587 14.142 7.32258 14.5161 7.32258C14.8903 7.32258 15.1935 7.62587 15.1935 8V12.5161C15.1935 13.8879 14.0815 15 12.7097 15H5.48387C4.11207 15 3 13.8879 3 12.5161V5.29032C3 3.91852 4.11207 2.80645 5.48387 2.80645H10C10.3741 2.80645 10.6774 3.10974 10.6774 3.48387C10.6774 3.858 10.3741 4.16129 10 4.16129H5.48387Z",
    fill: "#A954A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpand);
export default __webpack_public_path__ + "static/media/icon_expand.3ba463b098120f2b3fea89a9a803e77d.svg";
export { ForwardRef as ReactComponent };